import type {
  GarageCreateApiData,
  GarageCreateApiResponses,
  GarageDeleteApiData,
  GarageDeleteApiResponses,
  GarageGetApiData,
  GarageGetApiResponses,
  GarageListApiData,
  GarageListApiResponses,
  GarageMinimalListApiData,
  GarageMinimalListApiResponses,
  GaragePatchApiData,
  GaragePatchApiResponses,
  GarageStorageFacilityCreateApiData,
  GarageStorageFacilityCreateApiResponses,
  GarageStorageFacilityDeleteApiData,
  GarageStorageFacilityDeleteApiResponses,
  GarageStorageFacilityListApiData,
  GarageStorageFacilityListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getGarageUrls = {
  getPaginatedGarages: dataEndpoint<GarageListApiData, GarageListApiResponses>({
    getUrl: (queryParams) => apiUrl('garages/', queryParams)
  }),
  getPaginatedMinimalGarages: dataEndpoint<GarageMinimalListApiData, GarageMinimalListApiResponses>({
    getUrl: (queryParams) => apiUrl('garages/minimal/', queryParams)
  }),
  getGarage: dataEndpoint<GarageGetApiData, GarageGetApiResponses>({
    getUrl: ({ garageId }) => apiUrl(`garages/${garageId}/`)
  }),
  getGarageStorageFacilities: dataEndpoint<GarageStorageFacilityListApiData, GarageStorageFacilityListApiResponses>({
    getUrl: ({ garageId, ...queryParams }) => apiUrl(`garages/${garageId}/storage-facilities/`, queryParams)
  }),
  postGarage: responseEndpoint<GarageCreateApiData, GarageCreateApiResponses>({
    getUrl: () => apiUrl('garages/'),
    getBody: (data) => data
  }),
  postGarageStorageFacilities: responseEndpoint<
    GarageStorageFacilityCreateApiData,
    GarageStorageFacilityCreateApiResponses
  >({
    getUrl: ({ garageId }) => apiUrl(`garages/${garageId}/storage-facilities/`),
    getBody: ({ garageId: _, ...body }) => body
  }),
  patchGarage: responseEndpoint<GaragePatchApiData, GaragePatchApiResponses>({
    getUrl: ({ garageId }) => apiUrl(`garages/${garageId}/`),
    getBody: (data) => data
  }),
  patchGarageImage: responseEndpoint<GaragePatchApiData, GaragePatchApiResponses>({
    getUrl: ({ garageId }) => apiUrl(`garages/${garageId}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: (data) => data,
    skipBodyTransformation: true
  }),
  deleteGarage: dataEndpoint<GarageDeleteApiData, GarageDeleteApiResponses>({
    getUrl: ({ garageId }) => apiUrl(`garages/${garageId}/`)
  }),
  deleteGarageStorageFacility: dataEndpoint<
    GarageStorageFacilityDeleteApiData,
    GarageStorageFacilityDeleteApiResponses
  >({
    getUrl: ({ garageId, storageFacilityId }) => apiUrl(`garages/${garageId}/storage-facilities/${storageFacilityId}/`)
  })
};
